import { CARD_BRAND_LOGOS } from "@Light/components/account/PaymentMethod/PaymentMethodCard/PaymentMethodCard";
import { CreditCard01 } from "@untitledui/icons";

export type CardBrandMarkProps = {
  brand: string;
};

export const CardBrandMark = ({ brand }: CardBrandMarkProps) => {
  const Logo = CARD_BRAND_LOGOS[brand];
  if (!Logo) {
    return <CreditCard01 className="size-5" />;
  }
  return (
    <span className="flex h-4.25 w-6 items-center justify-center rounded-xs border border-secondary bg-primary p-px">
      <Logo className="h-full w-full" />
    </span>
  );
};
